import { connect, MapStateToProps } from "react-redux";

import { IAppState } from "@multiweb/types/react";
import { NavigationSection } from "../../navigation";
import { getFormChildIds } from "../../selectors";
import { FormListComponent, FormListComponentProps } from "../FormListComponent";

export type FormListProps = {
    subtreeRootId: number;
    /** Sekce, ve které je komponenta vykreslená. Slouží pro určování zaměření. */
    section: NavigationSection;
};

type StateProps = Pick<FormListComponentProps, "subtreeNodeIds">;

const mapStateToProps: MapStateToProps<StateProps, FormListProps, IAppState> = (state, { subtreeRootId }) => ({
    subtreeNodeIds: getFormChildIds(state, subtreeRootId),
});

/**
 * Získává ze stavu potomky vstupního formuláře.
 */
export const FormList = connect(mapStateToProps)(FormListComponent);
